module.exports = __webpack_public_path__ + "img/6.33da7308.png";